export default __webpack_public_path__ + "static/media/video2.ac64f9ac.mp4";